/**
 * Comments Hub
 * SignalR connection for real-time comment updates
 */
import * as signalR from '@microsoft/signalr';
import { API_CONFIG } from '@/config/api';
import { SIGNALR_CONFIG } from '@/constants/api';
import { signalrRetryPolicy } from './retryPolicy';

/**
 * Create a SignalR connection for comments hub
 * Uses infinite retry policy with exponential backoff capped at 30s
 */
export function createCommentsConnection(): signalR.HubConnection {
  const baseUrl = API_CONFIG.BASE_URL || window.location.origin;

  return new signalR.HubConnectionBuilder()
    .withUrl(`${baseUrl}${SIGNALR_CONFIG.HUB_PATH}`, {
      withCredentials: true,
    })
    .withAutomaticReconnect(signalrRetryPolicy)
    .configureLogging(signalR.LogLevel.Warning)
    .build();
}

export type CommentsConnection = signalR.HubConnection;
export { HubConnectionState } from '@microsoft/signalr';
